import { twAutoFlow } from './style/autoFlow'
import type { GridAutoFlowTypes } from './style/types'

export const getAutoFlowClasses = (options: GridAutoFlowTypes) => {
  return twAutoFlow[options]
}
